import jQuery from "jquery";
window.jQuery = jQuery;
$ = jQuery;

// window.GoogleAnalyticsDefined = window.ga !== undefined;
window.GoogleAnalyticsDefined = false;
window.FBPixelDefined = window.fbq !== undefined;
window.FBAnalyticsDefined = window.FB !== undefined;
window.GtmDefined = window.dataLayer !== undefined;
window.RedditPixelDefined = window.rdt !== undefined;
window.TiktokPixelDefined = window.ttq !== undefined;

window.currentVideoSeconds = 0;

//require('selectfield'); // DONT KNOW what this is supposed todo
import "./lib/jquery-ui-select/jquery-ui-select";
import "./lib/hpa-jquery-ui-select";
//require('jquery-datepicker'); // Don't think the datepicker is ever used
import "./lib/modernizr/modernizr";
import "parsleyjs";
import "./../less/bootstrap/bootstrap"; // NOT sure if the JS in bootstrap gets used?
import "velocity-animate";
import "./lib/imgLiquid/imgLiquid";
import "velocity-ui-pack";
import "./lib/waypoints/waypoints";
import "./lib/autotab/jquery.autotab";
import "./lib/chosen/chosen.jquery";
import "./lib/sweetalert/sweet-alert";
import "./lib/fitvids/jquery.fitvids";
// modules
import "./modules/courses";
import "./modules/authorPage";
import "./modules/load-more";
import "./modules/dashboard";
import "./modules/confirmation.js";
// import "./modules/confirmation2.js";
import "./modules/checkmemberemailfield.js";
// import "./modules/ga-ecommerce";
import "./modules/algoliaSearch";
import "./modules/gtm";
import "./modules/fb";
import "./modules/giveawayPage";
import "./modules/giveawayV2Page";
import "./modules/giveawayV2Enter";

import "./modules/timezone.picker.js";
import "./modules/promontionalWebinarSystem3";
import "./modules/jitWebinar";
import "./modules/pipeNotchingCalculator";
import "./modules/calculatorEmbed";
import "./modules/timeZoneAndCountDown";

import flare from "flare.js/dist/flare";
import "./modules/webinars";
import "./modules/multipleDealsPage";
import "./modules/webinarPackage";
import "./modules/couponPrizePage";
import "./modules/infoModal";
import "./modules/dateDisplay";
import "./modules/hpaCalendar";
import "./modules/emailSubscriptionPage";
import "./modules/memberNotifications";
import "./modules/header";
import "./modules/car2DB";
import "./modules/dashboardMembershipPage";
// import "./modules/courseNotes"; // tinymce doesn't work when includig this here. Need to add it to it's own file
import "./modules/contactUsPopupForm";
import "./modules/evc";
import "./modules/dealsPage";
import "./modules/podcastHolderPage";
import "./modules/memberReviews";
import "./modules/courseSales";
import "./modules/googleRecaptcha";

import { toggleHeaderSearchBackground } from "./functions";

$(function() {

    const $hpaFluentDropdown = $('#hpa-fluent-locale');
    if ($hpaFluentDropdown.length) {
        $hpaFluentDropdown.on('change', function() {
            const $this = $(this),
                value = $this.val();

            window.location.href = value;
        });
    }

    // Stop the site from being accessable when in an iFrame on another domain.
    // Create a redirect loop so the site is unusable.
    // The scam site http://hp.academy was using an iFrame to display the site
    // 2024-04-16 Commented it out so that Jono doesn't have problems when creating tests in VWO (https://vwo.com/)
    // if (window.self != window.top) {
    //     window.location.replace('https://www.hpacademy.com');
    // } else if (window.location !== window.parent.location) {
    //     window.location.replace('https://www.hpacademy.com');
    // }

    // Header dropdown parent items
    // On desktop (matches @screen-header-desktop) the dropdown opens on hover, so let the parent link navigate if it has a URL
    const isHeaderDesktop = function() {
      return window.matchMedia('(min-width: 1060px)').matches;
    };
    // A bare '#' is a placeholder, including when it's been localised to e.g. '/es/#'
    const dropItemHasUrl = function($link) {
      const href = ($link.attr('href') || '').trim();
      return href !== '' && href.slice(-1) !== '#';
    };

    // Touch screens at desktop width (tablets) can't hover, so the first tap opens the dropdown and the second tap navigates
    let dropItemTouchMoved = false;
    $('.site-header')
      .on('touchstart', '.cre-drop-item > a', function() {
        dropItemTouchMoved = false;
      })
      .on('touchmove', '.cre-drop-item > a', function() {
        dropItemTouchMoved = true;
      })
      .on('touchend', '.cre-drop-item > a', function(e) {
        const $this = $(this),
          $item = $this.parent('.cre-drop-item');

        if (dropItemTouchMoved || !isHeaderDesktop() || !dropItemHasUrl($this) || $item.hasClass('cre-touch-active')) {
          return;
        }

        // Stops the emulated hover and click so the link doesn't navigate on the first tap
        e.preventDefault();

        $('.site-header .cre-touch-active').removeClass('cre-touch-active');
        $item.addClass('cre-touch-active');
      });

    // Close a tapped-open dropdown when tapping anywhere else
    $(document).on('touchstart', function(e) {
      if (!$(e.target).closest('.cre-touch-active').length) {
        $('.site-header .cre-touch-active').removeClass('cre-touch-active');
      }
    });

    // This is for the mobile menu
    $('.site-header').on('click', '.cre-drop-item > a', function(e) {
      if (isHeaderDesktop() && dropItemHasUrl($(this))) {
        return;
      }

      e.preventDefault();

      $(this).parent('.cre-drop-item').toggleClass('cre-active');
    });

    var flareEmitter = flare.init();
    $(".article-content,.course,#wowza_player").fitVids();
    // .webinar-info .video-mask
    $(".video-trigger,.video-mask > a, .tech-article-info .video-mask, .promoVideoPreview .video-mask").imgLiquid({
        fill: true,
        horizontalAlign: "50%",
        verticalAlign: "0%"
    });

    /* ========================================================================
     * Select menu styling with jQuery UI
     * ======================================================================== */
    $("select.form-control")
        .not(".chosen")
        .not('.hpa-selectmenu')
        .selectmenu();

    /* ========================================================================
     * Chosen for select forms
     * ======================================================================== */
    $("select.form-control.chosen").chosen();

    /* ========================================================================
     * Equal Heights - generic
     * ======================================================================== */
    $(".equal-height").each(function() {
        var highestBox = 0;
        $(".equal", this).each(function() {
            if ($(this).outerHeight() > highestBox) {
                highestBox = $(this).outerHeight();
            }
        });
        $(".equal", this).height(highestBox);
    });

    /* ========================================================================
     * Radio Buttons
     * ======================================================================== */

    //helper class for styling of radio buttons
    var optionSet = $(".optionset"),
        checkbox = $(".checkbox");

    optionSet.each(function() {
        var checked = $(this).find($('input[type="radio"]'));
        checked.each(function() {
            if ($(this).is(":checked")) {
                $(this)
                    .parent("label")
                    .addClass("checked");
            }
        });
        checked.on("change", function() {
            $(this)
                .closest(".optionset")
                .find("label")
                .removeClass("checked");
            if ($(this).is(":checked")) {
                $(this)
                    .parent("label")
                    .addClass("checked");
            }
        });
    });

    /* ========================================================================
     * Credit card field group auto tab focus
     * ======================================================================== */
    // autotab was not working on some ipads using safari. Would only let them enter 3 numbers in each box.
    // $(".card-number").autotab("number");
    // $(".card-expiry").autotab("number");

    $('#CardNumber').on('change keyup', function() {
        const $this = $(this);
        let val = $this.val();
        if (val.length) {
            let newCCNumber = val.replace(/[^0-9]/g, '');
            if (newCCNumber) {
                const numberSplit = newCCNumber.match(/.{1,4}/g);
                if (numberSplit) {
                    newCCNumber = numberSplit.join('-');
                }
            }
            $this.val(newCCNumber);
            $this.parsley().validate();
        }
    });

    $('#CardNumber').on('focus', function() {
        const $this = $(this);

        $this.parsley().validate();
    });

    /* ========================================================================
     * CVC Tooltip
     * ======================================================================== */
    $(".cvc-tooltip").tooltip();
    $(".cvc-tooltip").on("click", function(e) {
        e.preventDefault();
    });

    function checkboxSetup() {
        checkbox.each(function() {
            var checked = $(this).find($('input[type="checkbox"]'));
            checked.each(function() {
                if ($(this).is(":checked")) {
                    $(this)
                        .parent("label")
                        .addClass("checked");
                }
            });
            checked.on("change", function() {
                $(this)
                    .closest(".checkbox")
                    .find("label")
                    .removeClass("checked");
                if ($(this).is(":checked")) {
                    $(this)
                        .parent("label")
                        .addClass("checked");
                }
            });
        });

    }
    checkboxSetup();
    /* ========================================================================
     * jQuery UI Datepicker - Dashboard Payment history filter
     * ======================================================================== */
    // WEBPACk DATEPICKER NEVER USED
    // var $paymentH = $('.DashboardPaymentHistoryPage');
    // if ($paymentH.length) {
    //     $('#dateFrom, #dateTo').datepicker({
    //         changeMonth: true,
    //         changeYear: true,
    //         showOn: "both",
    //         buttonImage: "themes/base/production/images/calendar.png",
    //         buttonImageOnly: true,
    //         showAnim: "fadeIn",
    //         yearRange: "-100:+0",
    //         dateFormat: "dd-mm-yy"
    //     });
    // }

    /* ========================================================================
     * MobileMenu -  header
     * ======================================================================== */

    function headerNav() {
        var subNavContainer = $(".js-hamburger");
        var submenu = $(".js-topNav");
        var siteHeader = $(".js-allHeader");
        subNavContainer.on("click", ".nav-trigger", function(event) {
            // open primary navigation on mobile
            event.preventDefault();
            subNavContainer.toggleClass("nav-open");
            submenu.toggleClass("TopNavToggle");
            var timeOut = 0;
            if (!submenu.hasClass("TopNavToggle")) {
                timeOut = window.setTimeout(function() {
                    submenu.addClass("disappear");
                }, 300);
                // siteHeader.css('position','fixed');
                // siteHeader.css('top',0);
                //console.log("hide Nav");
            } else {
                const headerSearchWrapper = $('#algolia-header-search2'),
                    $contactUsPopupFormWrapper = $('#contact-us-popup-form-wrapper');
                if (headerSearchWrapper.is(':visible')) {
                    headerSearchWrapper.hide();
                }
                $contactUsPopupFormWrapper.hide();

                //console.log("show Nav");
                window.clearTimeout(timeOut);
                submenu.removeClass("disappear");
                var currentTop = $(window).scrollTop();
                //console.log("current Top ", currentTop);
                // siteHeader.css('position','absolute');
                // siteHeader.css('top',currentTop);
            }
            //console.log('disappear--  removed');
            toggleHeaderSearchBackground();
        });
    }

    function headerScroll() {
        var $mainHeader = $(".site-header"),
            $menu = $(".js-topNav"),
            $hamBuger = $(".js-hamburger"),
            headerHeight = $mainHeader.height(),
            $aboutNav = $(".about-nav");

        var scrolling = false,
            previousTop = 0,
            currentTop = 0,
            scrollDelta = 10,
            scrollOffset = 150;

        var navTrigger = $(".js-navTrigger");

        if (navTrigger.length) {
            scrollOffset = navTrigger.offset().top - headerHeight;
        }
        // Don't run the menu hide code on devices that don't support
        // request animation frame
        if (window.requestAnimationFrame) {
            $(window).on("scroll", function() {
                if (!scrolling) {
                    scrolling = true;
                    requestAnimationFrame(autoHideHeader);
                }
            });

            $(window).on("resize", function() {
                headerHeight = $mainHeader.height();
            });
        }

        function autoHideHeader() {
            var currentTop = $(window).scrollTop();
            // is-at-top
            /*if (currentTop > 2) {
                $mainHeader.removeClass("homeHeaderIsAtTop");
            } else {
                $mainHeader.addClass("homeHeaderIsAtTop");
            }*/

            //there's no secondary nav or secondary nav is below primary nav
            if (previousTop - currentTop > scrollDelta) {
                //  if scrolling up...
                //$mainHeader.removeClass("is-hidden");
                if ($aboutNav.length) {
                    //$aboutNav.removeClass("about-fixed-top");
                }
            } else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
                // if scrolling down...
                /*$mainHeader.addClass("is-hidden");
                $menu.removeClass("TopNavToggle");
                $hamBuger.removeClass("nav-open");*/

                if ($aboutNav.length) {
                    $aboutNav.addClass("about-fixed-top");
                }
            }

            // about Us Nav

            if ($aboutNav.length) {
                //console.log('current Top', currentTop);
                // for now
                if (currentTop > 300) {
                    //console.log('should add');
                    $aboutNav.addClass("about-fixed");
                } else {
                    //console.log('should remove');
                    $aboutNav.removeClass("about-fixed");
                }
            }

            previousTop = currentTop;
            scrolling = false;
        }
    }
    headerNav();
    // set on if useStickyNav global Variable is not defined ( It can be set in templates)
    if (window["useStickyNav"] !== undefined) {
        if (useStickyNav) {
            headerScroll();
        }
    } else {
        headerScroll();
    }

    /* ========================================================================
     * Notification Message
     * ======================================================================== */

    // Close notification
    if ($(".close", ".notification").length) {
        $(".close", ".notification").on("click", function(e) {
            e.preventDefault();

            if ($('body[class*="Dashboard"]').length) {
                $(".notification")
                    .velocity({
                        translateX: "20px"
                    }, {
                        duration: 200
                    })
                    .velocity({
                        translateX: "-100%"
                    }, {
                        duration: 250,
                        complete: function() {
                            $(this)
                                .closest(".notification")
                                .removeClass("open");
                            $(this)
                                .closest(".notification h4 strong")
                                .text("");
                        }
                    });
                $(".dashboard").velocity({
                    paddingTop: "40px"
                }, {
                    duration: 300,
                    delay: 200,
                    easing: "swing"
                });
            } else {
                $(".notification")
                    .velocity({
                        translateX: "20px"
                    }, {
                        duration: 200
                    })
                    .velocity({
                        translateX: "-100%"
                    }, {
                        duration: 250,
                        complete: function() {
                            $(this)
                                .closest(".notification")
                                .removeClass("open");
                            $(this)
                                .closest(".notification h4 strong")
                                .text("");
                        }
                    });
                $(".site-main").velocity({
                    paddingTop: "0px"
                }, {
                    duration: 300,
                    delay: 200,
                    easing: "swing"
                });
            }
        });
    }

    /* ========================================================================
     * Course Accordion
     * ======================================================================== */

    $("#hpa-accordion .svg-chevron-up").hide();

    // Swapping out SVG when open
    // -------------------------------

    //When accordion section is opened
    $("#hpa-accordion").on("shown.bs.collapse", function() {
        //for each section
        $("#hpa-accordion .hpa-section").each(function() {
            //if the panel is open replace the chevron svg with the close svg
            if ($(this).find(".collapse").hasClass("in")) {
                $(this).find(".svg-chevron-down").hide();
                $(this).find(".svg-chevron-up").show();
                //and add the open class to the header (used to adjust svg styles)
                $(this).find(".panel-heading").addClass("open");
            }
        });
        if ($("#hpa-accordion .collapse").length === $("#hpa-accordion .collapse.in").length) {
            let textClose = $(".toggle-accordion").data('text-close');
            $(".toggle-accordion").text(textClose ? textClose : hpaTranslatedtext.initJs.accordionCloseAllDefault); // Close All

        }
        setTimeout(function() {
            $("#hpa-accordion .panel-collapse").removeClass("collapsing").addClass("collapse");
        }, 500);
        //When accordion section is closed
    }).on("hidden.bs.collapse", function() {
        //for each section
        $("#hpa-accordion .hpa-section").each(function() {
            //if the panel is closed replace the close svg with the chevron svg
            if (!$(this).find(".collapse").hasClass("in")) {
                $(this).find(".svg-chevron-down").show();
                $(this).find(".svg-chevron-up").hide();
                //and remove the open class
                $(this).find(".panel-heading").removeClass("open");
            }
        });
        if ($("#hpa-accordion .collapse").length === $("#hpa-accordion .collapse.in").length) {
            let textOpen = $(".toggle-accordion").data('text-open');
             $(".toggle-accordion").text(textOpen ? textOpen : hpaTranslatedtext.initJs.accordionExpandAllDefault); // Expand All

        }
        setTimeout(function() {
            $("#hpa-accordion .panel-collapse").removeClass("collapsing").addClass("collapse");
        }, 500);
    });

    // Open/Close all sections button
    // -------------------------------
    $(".toggle-accordion").on("click", function(e) {
        e.preventDefault();

        let textOpen = $(this).data('text-open'),
            textClose = $(this).data('text-close');

        if ($(this).text() === hpaTranslatedtext.initJs.accordionExpandAllDefault || $(this).text() === textOpen) {
            $("#hpa-accordion .collapse:not(.in)").each(function(index) {
                $(this).collapse("toggle");
            });
            $(this).text(textOpen ? textClose : hpaTranslatedtext.initJs.accordionCloseAllDefault); // Close All
        } else if ($(this).text() === hpaTranslatedtext.initJs.accordionCloseAllDefault || $(this).text() === textClose) {
            $("#hpa-accordion .collapse.in").each(function(index) {
                $(this).collapse("toggle");
            });
            $(this).text(textClose ? textOpen : hpaTranslatedtext.initJs.accordionExpandAllDefault); // Expand All
        }
    });

    const $hpaAccordion2Outer = $('.hpa-accordion2-outer');
    if ($hpaAccordion2Outer.length) {
        $hpaAccordion2Outer.each(function() {
            const $outer = $(this),
                $accordion2 = $outer.find('.hpa-accordion2'),
                $toggleAccordion2 = $outer.find('.toggle-accordion2'),
                $hpaSection = $accordion2.find('.hpa-section2');

            $accordion2.find('.svg-chevron-up').hide();

            // Swapping out SVG when open
            // -------------------------------

            //When accordion section is opened
            $accordion2.on("shown.bs.collapse", function() {
                const $panelCollapse = $hpaSection.find('.panel-collapse'),
                    $panelCollapseIn = $hpaSection.find('.panel-collapse.in');

                if ($hpaSection.length) {
                    $hpaSection.each(function() {
                        const $this = $(this);
                        //if the panel is open replace the chevron svg with the close svg
                        if ($this.find('.collapse').hasClass('in')) {
                            $this.find('.svg-chevron-down').hide();
                            $this.find('.svg-chevron-up').show();
                            //and add the open class to the header (used to adjust svg styles)
                            $this.find('.panel-heading').addClass('open');
                        }
                    });
                }
                if ($panelCollapse.length === $panelCollapseIn.length) {
                    $toggleAccordion2.text(hpaTranslatedtext.initJs.accordionCloseAllDefault); // Close All

                }

                setTimeout(function() {
                    $panelCollapse.removeClass('collapsing').addClass('collapse')
                }, 500);
                //When accordion section is closed
            }).on("hidden.bs.collapse", function() {
                const $panelCollapse = $hpaSection.find('.panel-collapse'),
                    $panelCollapseIn = $hpaSection.find('.panel-collapse.in');
                //for each section
                $hpaSection.each(function() {
                    const $this = $(this);

                    //if the panel is closed replace the close svg with the chevron svg
                    if (!$this.find('.collapse').hasClass('in')) {
                        $this.find('.svg-chevron-down').show();
                        $this.find('.svg-chevron-up').hide();
                        //and remove the open class
                        $this.find('.panel-heading').removeClass('open');
                    }
                });
                if ($panelCollapse.length === $panelCollapseIn.length) {
                    $toggleAccordion2.text(hpaTranslatedtext.initJs.accordionExpandAllDefault); // Expand All

                }

                setTimeout(function() {
                    $panelCollapse.removeClass('collapsing').addClass('collapse');
                }, 500);
            });

            // Open/Close all sections button
            // -------------------------------
            $toggleAccordion2.on('click', function(e) {
                e.preventDefault();

                const $this = $(this);

                if ($this.text() === hpaTranslatedtext.initJs.accordionExpandAllDefault) { // Expand All
                    $hpaSection.find('.collapse:not(.in)').each(function(index) {
                        $(this).collapse('toggle');
                    });
                    $this.text(hpaTranslatedtext.initJs.accordionCloseAllDefault); // Close All
                } else if ($this.text() === hpaTranslatedtext.initJs.accordionCloseAllDefault) {
                    $hpaSection.find('.collapse.in').each(function(index) {
                        $(this).collapse('toggle');
                    });
                    $this.text(hpaTranslatedtext.initJs.accordionExpandAllDefault); // Expand All
                }
            });
        });
    }

    /* ========================================================================
     * Dashboard - Payment Accordion
     * ======================================================================== */

    //When accordion section is opened
    $("#dashboard-accordion")
        .on("shown.bs.collapse", function() {
            var svg = $(this).find(".panel-heading svg");
            let textClose = $(this).data('text-close');
            if (!textClose) textClose = 'Cancel';

            svg.html(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="306.4 106.4 347.2 347.2" enable-background="new 306.4 106.4 347.2 347.2"><path d="M644.3 405.1l-39.2 39.2c-5.6 5.6-13.1 7.5-20.5 7.5-7.5 0-14.9-3.7-20.5-7.5l-84-84-85.9 85.9c-5.6 5.6-13.1 7.5-20.5 7.5s-14.9-3.7-20.5-7.5L314 407c-5.6-5.6-7.5-13.1-7.5-20.5 0-7.5 3.7-14.9 7.5-20.5l85.9-85.9-85.9-85.9c-5.6-5.6-7.5-13.1-7.5-20.5s3.7-14.9 7.5-20.5l39.2-39.2c7.5-3.7 14.9-7.5 20.5-7.5s14.9 3.7 20.5 7.5l85.9 85.9L566 114c5.6-5.6 13.1-7.5 20.5-7.5 7.5 0 14.9 3.7 20.5 7.5l39.2 39.2c5.6 5.6 7.5 13.1 7.5 20.5 0 7.5-3.7 14.9-7.5 20.5L560.3 280l85.9 85.9c5.6 5.6 7.5 13.1 7.5 20.5-.1 7.5-3.8 13.1-9.4 18.7z"/></svg>'
            );

            //if the panel is open replace the chevron svg with the close svg
            if (
                $(this)
                .find($(".collapse"))
                .hasClass("in")
            ) {
                $(this)
                    .find(".panel-heading h5 span")
                    .text(textClose);
            }
            $(this)
                .find(".panel-heading")
                .addClass("open");

            //When accordion section is closed
        })
        .on("hidden.bs.collapse", function() {
            var svg = $(this).find(".panel-heading svg");
            let textOpen = $(this).data('text-open');
            if (!textOpen) textOpen = 'Edit Method';
            console.log(textOpen);
            svg.html(
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.8 47.8" enable-background="new 0 0 47.8 47.8"><path d="M39.4 21.6L13.1 47.8H0V34.7L26.3 8.4l13.1 13.2zM14.3 40.9l-7.4-7.4L4 36.4v3.4h4v4h3.4l2.9-2.9zm13-27.1c-.2 0-.4.1-.5.2L9.6 31.1c-.2.2-.2.3-.2.5 0 .4.3.7.7.7.2 0 .4-.1.5-.2L27.8 15c.2-.2.2-.3.2-.5 0-.4-.3-.7-.7-.7zm19.4.5l-5.2 5.2L28.3 6.4l5.2-5.2C34.3.4 35.3 0 36.4 0c1.1 0 2.1.4 2.9 1.2l7.4 7.4c.7.8 1.2 1.8 1.2 2.9s-.5 2.1-1.2 2.8z"/></svg>'
            );
            //if the panel is closed replace the close svg with the chevron svg
            if (!$(this)
                .find($(".collapse"))
                .hasClass("in")
            ) {
                $(this)
                    .find(".panel-heading h5 span")
                    .text(textOpen);
            }
            $(this)
                .find(".panel-heading")
                .removeClass("open");
        });

    /* ========================================================================
     * Small Form - label positioning
     * ======================================================================== */

    if ($(".form-group input", ".small-form").length) {
        $(".form-group input", ".small-form").each(function() {
            var labelW = $(this)
                .siblings("label")
                .width();
            $(this).css({ paddingRight: labelW + 25 });
            if ($(this).val() != "") {
                $(this)
                    .siblings("label")
                    .addClass("label-show");
            } else {
                $(this)
                    .siblings("label")
                    .removeClass("label-show");
            }
        });
    }
    $(".form-group input", ".small-form").on("keyup click", function() {
        if ($(this).val() != "") {
            $(this)
                .siblings("label")
                .addClass("label-show");
        } else {
            $(this)
                .siblings("label")
                .removeClass("label-show");
        }
    });

    /* ========================================================================
     * Prevent double submits - e.g. on mobile a double tap, or Chrome's password autofill submitting the form as the user taps the button
     * ======================================================================== */
    // Delegated so it runs after Parsley, which stops the event if the form is invalid
    $(document).on("submit", ".js-preventDoubleSubmit", function(e) {
        const $form = $(this);

        if ($form.data("submitting")) {
            e.preventDefault();
            return false;
        }
        $form.data("submitting", true);

        // Don't disable the button straight away, otherwise its name (e.g. action_dologin) isn't sent with the form
        setTimeout(function() {
            $form.find('[type="submit"]').prop("disabled", true);
        }, 0);

        // Let them try again if the request fails or takes too long
        setTimeout(function() {
            $form.data("submitting", false);
            $form.find('[type="submit"]').prop("disabled", false);
        }, 10000);
    });

    // Reset if the page is restored from the back/forward cache
    $(window).on("pageshow", function(e) {
        if (e.originalEvent.persisted) {
            $(".js-preventDoubleSubmit").data("submitting", false).find('[type="submit"]').prop("disabled", false);
        }
    });

    /* ========================================================================
     * Anchor Links - Scroll
     * ======================================================================== */
    //smooth scroll to anchor links - detects anchors automatically
    $(".about-nav-wrap .about-nav a, .banner-caption a, .js-smoothScroll").click(function() {
        //if an element on the page has the same pathname as the link
        //console.log("clicked smooth");
        if (
            location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") &&
            location.hostname == this.hostname
        ) {
            var target = $(this.hash);
            //find if there is a target that has an id that matches the href of the link
            target = target.length ? target : $("[id=" + this.hash.slice(1) + "]");
            if (target.length) {
                //if so scroll the page to that element
                //Stop scrolling if user scrolls
                $("html, body").bind("scroll mousedown DOMMouseScroll mousewheel keyup", function() {
                    $("html, body").stop();
                });
                //go to destination
                if (target.offset().top <= $(".nav-trigger").offset().top) {
                    $("html, body").animate({
                            scrollTop: target.offset().top
                        },
                        1000,
                        "swing",
                        function() {
                            $("html, body").unbind("scroll mousedown DOMMouseScroll mousewheel keyup");
                        }
                    );
                } else {
                    $("html, body").animate({
                            scrollTop: target.offset().top - ($(".navbar-fixed-top").height() + $("nav-trigger>nav").height())
                        },
                        1000,
                        "swing",
                        function() {
                            $("html, body").unbind("scroll mousedown DOMMouseScroll mousewheel keyup");
                        }
                    );
                }

                //reset focus on element
                $(this).blur();

                return false;
            }
        }
    });

    $(".btn-header").on("click", function() {
        $(this).blur();
    });

    // Waypoints Helper functions
    // Get link by section or article id
    function getRelatedNavigation(el) {
        var id = $(el).attr("id");
        if (id) {
            var selector = ".about-nav a[href$='#" + id + "']";
            return $(selector);
        }
        return false;
    }

    if ($(".about-nav a").length) {
        $("article")
            .waypoint(
                function(direction) {
                    var artitleSelector = getRelatedNavigation(this);
                    if (artitleSelector) {
                        artitleSelector.parent("li").toggleClass("active", direction === "down");
                    }
                }, {
                    offset: 149
                }
            )
            .waypoint(
                function(direction) {
                    var artitleSelector = getRelatedNavigation(this);
                    if (artitleSelector) {
                        artitleSelector.parent("li").toggleClass("active", direction === "up");
                    }
                }, {
                    offset: function() {
                        return -$(this).height() + 149;
                    }
                }
            );
    }

    /* ========================================================================
     * Video Modal - Set video
     * ======================================================================== */

    var video = $("iframe", "#videoModal");

    $(".modal-header .close").on("click", function() {
        video.attr("src", "");
    });

    $("#videoModal").on("hidden.bs.modal", function() {
        video.attr("src", "");
    });

    $(document).on("touch click", ".js_paymentPlanPurchase", function(e) {
        e.preventDefault();
        //if we have a combo purchase form
        var $comboPurchaseForm = $("#ComboPurchaseForm_ComboPurchaseForm");
        if ($comboPurchaseForm.length) {
            // if the user is registered
            $comboPurchaseForm.find("input[name=OpenPaymentPlanOptions]").val(1);
            // TODO set a hidden value on the form to display payment Plan options
            if ($comboPurchaseForm.find(".btn-submit").hasClass("trigger-register-starterPackage")) {
                // trigger the register event
                return $comboPurchaseForm.find(".trigger-register-starterPackage").trigger("click");
            } else {
                return $comboPurchaseForm.find(".loggedIn-starterPackage").trigger("click");
                // submit the form
                // $comboPurchaseForm.submit();
            }
        }
        var $this = $(this);
        var $purchaseLink = $(".js-purchaseLink");
        if ($purchaseLink.length) {
            if ($purchaseLink.hasClass("trigger-register")) {
                // if logged Off
                var backURL = $purchaseLink.data("backurl");
                backURL = backURL + "?paymentplan=1";
                $purchaseLink.data("backurl", backURL);
                $purchaseLink.trigger("click");
            } else {
                // if logged on
                var purchaseURL = $purchaseLink.attr("href");
                purchaseURL = purchaseURL + "?paymentplan=1";
                $purchaseLink.attr("href", purchaseURL);
                $purchaseLink.trigger("click");
                // in case the click trigger does not work
                window.location.href = purchaseURL;
            }
        }
    });

    $(document).on("touch click", ".js-displayLoginPrompt", function(e) {
        e.preventDefault();
        $("#registerModal").modal("hide");
        if ($('body').data('isstaticpage')) {
            // if it's a atatic page, ajax up a login form so we can get a fresh security token
            var backurl = $(this).data("backurl");
            if (backurl) {
                var callback = "/account/ajaxloginpopup?backurl=" + escape(backurl);
            } else {
                var callback = "/account/ajaxloginpopup";
            }

            $.get(callback).done(function(data) {
                $('#signinModalParent').html(data);
                checkboxSetup();
                $("#signinModal").modal();
            });
        } else {
            $("#signinModal").modal();
        }
    });

    // Custom order page: show the sign in modal straight away if they're not logged in
    if ($(".js-autoShowSigninModal").length && $("#signinModal").length) {
        $("#signinModal").modal();
    }

    function loadAjaxRegisterFormIfStatic($btn, $form, callback) {

        let isCheckout = '0';
        if ($btn.hasClass('js-ga_addProductToCart')) {
            isCheckout = '1';
        }

        if ($('body').data('isstaticpage')) {
            // if it's a atatic page, ajax up a login form so we can get a fresh security token
            // todo ajax spinner?
            var backurl = $btn.data("backurl");
            if (backurl) {
                var request = "/account/ajaxregisterpopup?backurl=" + escape(backurl);
            } else {
                var request = "/account/ajaxregisterpopup";
            }

            $.get(request).done(function(data) {
                $('#registerModalParent').html(data);
                $('.js_facebookLoginLink, .js-loginModalSubmitButton, .js-registerModalSubmitButton').data('is-checkout', isCheckout);
                checkboxSetup();
                callback($btn, $form);
            });
        } else {
            $('.js_facebookLoginLink, .js-loginModalSubmitButton, .js-registerModalSubmitButton').data('is-checkout', isCheckout);
            callback($btn, $form);
        }
    }
    /* ========================================================================
     * Registration buttons
     * ======================================================================== */
    $(document).on("touch click", ".trigger-register", function(e) {
        e.preventDefault();
        var $btn = $(this);


        loadAjaxRegisterFormIfStatic($btn, false, function($btn) {
            if (GoogleAnalyticsDefined) {
                ga("send", "event", "UX", "click", "register Popup triggered");
            }

            if (GoogleAnalyticsDefined) {
                ga("send", "event", "UX", "click", "register Popup triggered");
            }
            if (window.FBAnalyticsDefined) {
                FB.AppEvents.logEvent("register_Popup_tiggered");
            }

            var accountTypeAttr = $btn.attr("membertype");
            $("#registerModal input[name=MemberType]").val(accountTypeAttr);
            var $accountTypeText = $("#registerAccountTypeText");
            var $stepInfoText = $("#step-info");
            var accountText = hpaTranslatedtext.initJs.registrationPromptPrefix; // Please enter your details below to register for
            switch (accountTypeAttr) {
                case "free":
                    $('#registerModal .main-text').html(accountText +  '<span id="registerAccountTypeText">' + hpaTranslatedtext.initJs.freeAccountText + '</span>'); // a free account
                    $('#registerModal *[type="submit"]').text(hpaTranslatedtext.initJs.registrationModalContinueButton); // Continue
                    if ($btn.data("backurl").length) {
                        // $stepInfoText.html("Step 1 of 2");
                    } else {
                        // $stepInfoText.html("Step 1 of 2");
                    }
                    break;
                case "gold":
                    $('#registerModal .main-text').html(accountText +  '<span id="registerAccountTypeText">' + hpaTranslatedtext.initJs.goldAccountText + '</span>'); // a gold account
                    $('#registerModal [type="submit"]').text(hpaTranslatedtext.initJs.registrationModalContinueButton); // Continue
                    // $stepInfoText.html("Step 1 of 2");
                    break;
                default:
                    if ($btn.data("backurl").length) {
                        // $stepInfoText.html("Step 1 of 2");
                    } else {
                        // $stepInfoText.html("Step 1 of 2");
                    }
                    break;
            }

            if ($btn.data("backurl").length) {
                $("#registerModal input[name=BackURL]").val($btn.data("backurl"));
                $("#signinModal input[name=BackURL]").val($btn.data("backurl"));
                var updatedFacebookLoginLink = $(".js_facebookLoginLink").attr("href");
                updatedFacebookLoginLink = updatedFacebookLoginLink + "?redirect=" + encodeURI($btn.data("backurl"));
                $(".js_facebookLoginLink").attr("href", updatedFacebookLoginLink);
                // login
            }

            $("#registerModal").modal();
        });


    });

    $(".register-sign-in-modal").on("click touch", function() {
        $("#registerModal").modal("hide");
    });

    $(document).on("touch click", ".loggedIn-starterPackage", function(e) {
        const $btn = $(this),
            $form = $btn.closest('form');

        if (!$form.parsley().isValid()) {
            if ($form.find(".js-optionalCourseValidation").length) {
                $form.find(".js-optionalCourseValidation").show();
            }
            return true;
        }
        if ($form.find(".js-optionalCourseValidation").length) {
            $form.find(".js-optionalCourseValidation").hide();
        }
        $form.submit();
    });

    $(document).on("touch click", ".trigger-register-starterPackage", function(e) {
        const $btn = $(this),
            $form = $btn.closest('form');

        if (!$form
            .parsley()
            .isValid()
        ) {
            if ($(".js-optionalCourseValidation").length) {
                $(".js-optionalCourseValidation").show();
            }
            return true;
        }
        if ($(".js-optionalCourseValidation").length) {
            $(".js-optionalCourseValidation").hide();
        }
        e.preventDefault();

        loadAjaxRegisterFormIfStatic($btn, $form, function($btn, $form) {


            if (GoogleAnalyticsDefined) {
                ga("send", "event", "UX", "click", "register Popup triggered");
            }

            var $accountTypeText = $("#registerAccountTypeText");
            var $stepInfoText = $("#step-info");
            $accountTypeText.html("an account");
            $stepInfoText.html("Step 1 of 2");
            var optionalCourse = $form.find("select[name=OptionalCourses1]").val();
            var openPaymentPlanOptions = $form.find("input[name=OpenPaymentPlanOptions]").val();
            var backURL =
                $btn.data("backurl") +
                "?autoSubmit=true&OptionalCourses1=" +
                optionalCourse +
                "&OpenPaymentPlanOptions=" +
                openPaymentPlanOptions +
                "&FormID=" +
                $form.attr('id');

            $("#registerModal input[name=BackURL]").val(backURL);
            // also update the sign in Modal
            $("#signinModal input[name=BackURL]").val(backURL);
            $("#registerModal .js-displayLoginPrompt").attr('href', backURL + '#');

            $("#registerModal .js-displayLoginPrompt").attr('data-backurl', backURL);

            var updatedFacebookLoginLink = $(".js_facebookLoginLink").attr("href");
            updatedFacebookLoginLink = updatedFacebookLoginLink + "?redirect=" + escape(backURL);
            $(".js_facebookLoginLink").attr("href", updatedFacebookLoginLink);

            $("#registerModal").modal();
        });
    });
    // quick function to submit a form automatically ( used on starter package page )
    if (getQueryVariable("autoSubmit")) {
        const formID = (getQueryVariable("FormID") ? getQueryVariable("FormID") : 'ComboPurchaseForm_ComboPurchaseForm');
        const $form = $('#' + formID);
        if ($form.length) {
            // quick and dirty form repopulation
            var optionalCourse = getQueryVariable("OptionalCourses1");
            if (optionalCourse) {
                $form.find("select[name=OptionalCourses1]").val(optionalCourse);
            }
            var openPaymentPlanOptions = getQueryVariable("OpenPaymentPlanOptions");
            if (openPaymentPlanOptions) {
                $form.find("input[name=OpenPaymentPlanOptions]").val(openPaymentPlanOptions);
            }

            var purchaseButton = $('.js-ga_addProductToCart');
            if (purchaseButton.length && purchaseButton.hasClass('trigger-register-starterPackage')) {
                purchaseButton[0].click();
            } else {
                $form.submit();
            }
        } else {
            var purchaseButton = $('.js-purchaseLink');
            if (purchaseButton.length) {
                purchaseButton[0].click();
            }
        }
    }

    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return false;
    }

    $('.video-modal-trigger').on('click', function() {
        const $this = $(this),
            modal = $('#' + $this.data('modal-id'));

        modal.find('iframe').attr('src', $this.data('iframe-src'));
        modal.modal('show');
    });

    $('.alert-vip-offer-close').on('click', function() {
        const $this = $(this);
        let days = 1;
        const date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));

        document.cookie = 'hpa-vip-offer-alert=hide; expires=' + date.toGMTString() + '; path=/';
    });

    if (document.cookie.indexOf('hpa-vip-offer-alert=hide') !== -1) {
        $('.alert-vip-offer').remove();
    }

    // used to display a facebook error
    if ($('#ReferralModal').length && $('#ReferralModal').data('display')) {
        $("#ReferralModal").modal();
    }

    $('.scrollto').on('click', function(e) {
        e.preventDefault();

        var $this = $(this),
            scrollToSelector = $this.data('scrollto-selector'),
            scrollToEl = $(scrollToSelector);

        if (scrollToEl.length) {
            $('html, body').animate({
                scrollTop: scrollToEl.offset().top
            });
        }
    });
});



// WEBPACK FOOTER //
// ./js/init.js